export const STATIC_DIR = 'static';
export const S3_ASSET_PREFIX = 'static-components';

export const STATIC_PUBLIC_PATH = `/${STATIC_DIR}/${S3_ASSET_PREFIX}`;
export const ICONS_PUBLIC_PATH = `${STATIC_PUBLIC_PATH}/icons`;

export const DATA_ISLAND_ID = '__STATIC_COMPONENTS_DATA__';
export const CSS_SCOPE_CLS = 'static-component';
export const IS_PROD = process.env.NODE_ENV === 'production';
